import { hasClosest } from '../../app/helpers'

const CSS = {
  parent: 'unveil',
  unveiled: 'unveiled',
}

class PicUnveiler {
  constructor () {
    this.els = document.getElementsByClassName(CSS.parent)

    this.init()
  }

  unveil(el) {
    if(el) {
      return el.classList.add(CSS.unveiled)
    }

    /**
     * Unveil elements not having the `unveiled` class yet but having their
     * images `complete` (downloaded and already available to the browser).
     */
    Array.from(this.els)
      .filter(
        el => !el.classList.contains(CSS.unveiled)
        && el.querySelector('img').complete
      )
      .forEach(el => this.unveil(el))
  }

  onLoad(e) {
    const unveilParent = e.target.closest(`.${CSS.parent}`)
    if (unveilParent) {
      this.unveil(unveilParent)
    }
  }

  init() {
    // Unveil pictures being already loaded before module initialization.
    this.unveil()
  }
}

export default function(app) {
  return new PicUnveiler(app)
}



// WEBPACK FOOTER //
// ./resources/js/modules/PicUnveiler/index.js